import React from "react";
import { Link } from "react-router-dom";

function RegistrationSuccess() {
    return (
        <div style={{ maxWidth: 500, margin: "2rem auto", padding: "1rem", textAlign: "center" }}>
            <h2>Registration Successful!</h2>
            <p>Your vendor account has been created.</p>
            <Link to="/login">
                <button style={{ marginTop: "1rem" }}>Go to Login</button>
            </Link>
        </div>
    );
}

export default RegistrationSuccess;